import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';

import { useUserStore } from '../store/user/user';

const useUserComposable = () => {
    const store = useStore();
    const company_id = computed(() => {
        return store.getters['auth/userCompanyId']?.id;
    });

    const loggedUser = computed(() => {
        return store.getters['auth/loggedUser'];
    });

    const isGodUser = computed(() => {
        return store.getters['auth/isGodUser'];
    });

    const userPermissions = computed(() => {
        return store.getters['auth/getUserPermissions'];
    });

    const params = ref({
        page_size: null,
        page: null,
    });

    const { loading, user, users, totalUserRecords } = storeToRefs(useUserStore());
    const { fetchAllUsers, fetchUserDetails, createUser, updateUserDetails, checkUserMFA, setUsers } = useUserStore();

    const getAllUsers = (userParams) => {
        fetchAllUsers(company_id.value, userParams ?? params.value);
    };

    const getUserById = async (userId) => {
        return await fetchUserDetails(userId, company_id.value);
    };

    const getUserMFAById = async (userId) => {
        return await checkUserMFA(userId, company_id.value);
    };

    const addUser = async (body) => {
        return await createUser({
            name: body.name,
            surname: body.surname,
            email: body.email,
            company_id: company_id.value,
            mail_otp: body.mail_otp,
        });
    };

    const updateUser = async (userId, body) => {
        await updateUserDetails(userId, { ...body, company_id: company_id.value });
    };

    // check has the permission that user wants to check
    const checkUserPermission = (check) => {
        // console.log(check);
        // console.log(userPermissions.value);
        let havePermission = Object.values(userPermissions.value).filter((item) => item.code == check);
        if (havePermission && havePermission.length > 0) {
            // console.log('User have permission to do ' + check);
            return true;
        }
        return false;
    };
    return {
        isGodUser,
        loggedUser,
        company_id,
        loading,
        user,
        users,
        checkUserPermission,
        totalUserRecords,
        getAllUsers,
        addUser,
        getUserById,
        getUserMFAById,
        updateUser,
        setUsers,
    };
};

export default useUserComposable;
